<section
  *ngIf="visible() && state() as s"
  class="onb-hero"
  [class.is-near-complete]="progress() >= 70"
  role="region"
  [attr.aria-label]="'onboarding.hero.aria_region' | transloco"
>
  <div class="onb-hero-glow" aria-hidden="true"></div>

  <div class="onb-hero-grid">
    <!-- Left : message principal -->
    <div class="onb-hero-content">
      <div class="onb-hero-tag">
        <span class="material-icons-outlined">rocket_launch</span>
        {{ 'onboarding.hero.tag' | transloco }}
      </div>
      <h2 class="onb-hero-title">
        <ng-container *ngIf="progress() === 0">
          {{ 'onboarding.hero.title_zero' | transloco }}
        </ng-container>
        <ng-container *ngIf="progress() > 0 && progress() < 70">
          {{ 'onboarding.hero.title_progress' | transloco: { count: remainingCount() } }}
        </ng-container>
        <ng-container *ngIf="progress() >= 70 && !isComplete()">
          {{ 'onboarding.hero.title_near' | transloco: { count: remainingCount() } }}
        </ng-container>
      </h2>
      <p class="onb-hero-sub">
        {{ 'onboarding.hero.sub' | transloco }}
      </p>

      <!-- Progress bar -->
      <div class="onb-hero-progress">
        <div class="onb-hero-progress-track">
          <div
            class="onb-hero-progress-fill"
            [style.width.%]="progress()"
          ></div>
        </div>
        <span class="onb-hero-progress-pct">{{ progress() }}%</span>
      </div>

      <!-- Chips priorités -->
      <div class="onb-hero-chips" *ngIf="priorityChips().length">
        <button
          *ngFor="let step of priorityChips()"
          type="button"
          class="onb-hero-chip"
          (click)="startStep(step, $event)"
          [attr.aria-label]="t('onboarding.actions.start') + ' — ' + step.title"
        >
          <span class="material-icons-outlined">{{ step.icon }}</span>
          <span class="onb-hero-chip-label">{{ step.title }}</span>
          <span class="onb-hero-chip-arrow material-icons-outlined">arrow_forward</span>
        </button>
      </div>

      <!-- Actions -->
      <div class="onb-hero-actions">
        <vd-button variant="primary" size="lg" (click)="openDrawer()">
          <span slot="leading" class="material-icons-outlined">checklist</span>
          {{ 'onboarding.actions.view_steps' | transloco }}
        </vd-button>
        <button type="button" class="onb-hero-hide" (click)="hide()">
          {{ 'onboarding.actions.hide_session' | transloco }}
        </button>
      </div>
    </div>

    <!-- Right : illustration mini-stats -->
    <aside class="onb-hero-aside" aria-hidden="true">
      <div class="onb-hero-stat">
        <span class="onb-hero-stat-num">{{ s.done }}</span>
        <span class="onb-hero-stat-lbl">{{ 'onboarding.hero.stat_done' | transloco }}</span>
      </div>
      <div class="onb-hero-stat">
        <span class="onb-hero-stat-num">{{ s.partial }}</span>
        <span class="onb-hero-stat-lbl">{{ 'onboarding.hero.stat_partial' | transloco }}</span>
      </div>
      <div class="onb-hero-stat">
        <span class="onb-hero-stat-num">{{ s.total - s.done - s.partial }}</span>
        <span class="onb-hero-stat-lbl">{{ 'onboarding.hero.stat_todo' | transloco }}</span>
      </div>
    </aside>
  </div>
</section>
